import React from 'react';
import { I18nextProvider } from 'react-i18next';
import Bugsnag from '@bugsnag/js';
import az from './locales/az.json';
import ru from './locales/ru.json';

document.addEventListener('DOMContentLoaded', async () => {
  const container = document.getElementById('frequently-asked-questions-app');
  if (container) {
    try {
      const [{ createRoot }, { ContextWrapper }, { Header }, { Content }, { customizeI18n }] =
        await Promise.all([
          import('react-dom/client'),
          import('./context/ContextWrapper'),
          import('./components/header'),
          import('./components/content'),
          import('../utils/i18n')
        ]);
      const dataset = JSON.parse(JSON.stringify(container.dataset));
      const i18n = customizeI18n({ az, ru });

      createRoot(container).render(
        <I18nextProvider {...{ i18n }}>
          <ContextWrapper {...{ dataset }}>
            <Header />
            <Content />
          </ContextWrapper>
        </I18nextProvider>
      );
    } catch (error) {
      console.error('Error initializing frequently-asked-questions-app:', error);
      Bugsnag.notify(error);
    }
  }
});
